import toast from 'react-hot-toast'
import Axios from '../services/axios'

export const fetchData = async (method = 'POST', url, payload = {}) => {
  try {
    const methods = {
      POST: () => Axios.post(url, payload),
      GET: () => Axios.get(url),
      PUT: () => Axios.put(url, payload),
      DELETEBODY: () => Axios.delete(url, { data: payload }),
      DELETE: () => Axios.delete(url)
    }

    if (methods[method]) {
      const response = await methods[method]()
      return response?.data
    } else {
      throw new Error(`Unsupported HTTP method: ${method}`)
    }
  } catch (error) {
    console.log(error)
    if (
      url === '/v3/pricelists/search' ||
      url === '/v3/patient/checkFollowup' ||
      url === '/v3/patient-alert/getByPatient' ||
      url === '/v3/patient-history/latest-pregnancy' ||
      url === '/v3/patient-history/clinical-summary' ||
      url === '/v3/RCM/sendPreAuth' ||
      url === '/emr/updateItemsField' ||
      url === '/v3/emr/updateItemsField'||
      url === '/v3/patient/recordSummary' 
    )
      return
    if (url === '/v3/emr/getById' || url === '/v3/erpGL/glSend') {
      throw error
    }
    toast.error(
      error?.response?.data?.details ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        `Error`
    )
    // throw error
  }
}

export const downloadFile = async (
  method = 'GET',
  url,
  payload = {},
  defaultFilename = 'download.xlsx'
) => {
  try {
    const config = { responseType: 'blob' }

    const methods = {
      POST: () => Axios.post(url, payload, config),
      GET: () => Axios.get(url, config)
    }

    if (!methods[method]) {
      throw new Error(`Unsupported HTTP method for file download: ${method}`)
    }

    const response = await methods[method]()

    const blob = new Blob([response.data], {
      type: response.headers['content-type']
    })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)

    const filename =
      response.headers['content-disposition']
        ?.split('filename=')[1]
        ?.replace(/['"]/g, '') || defaultFilename

    link.download = filename
    link.click()
  } catch (error) {
    console.error(error)
    toast.error(
      error?.response?.data?.details ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        `Download failed`
    )
  }
}
